// extracted by css-extract-rspack-plugin
export default {"link":"_5d0580c0","container":"_90182067","isMobile":"_d6edecfa","image":"_596269c7","textArea":"_969246ea","title":"_2cebe0a0","description":"_bb7cbcc6","button":"_615c24b6"};